import { render } from "./iPads.vue?vue&type=template&id=c9c486b6"
import script from "./iPads.vue?vue&type=script&lang=js"
export * from "./iPads.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__